import BrandSettings from './BrandSettings'
import BackButton from 'Shared/components/BackButton'
import { Loading } from 'react-admin'
import useAct from '../useAct'
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'
import TextContent from './TextContent'
import VolunteerPageSettings from './VolunteerPageSettings'
import validate from '../lib/validator';

export default function Form() {
  const act = useAct()
  const [tab, setTab] = useState('brandSettings')

  const brand = useSel((s) => s.brand)
  const { loaded, error, validationErrors, dirty } = useSel((s) => s.local)

  const tabClasses = (thisTab) => {
    let classes = ['tab']
    if (thisTab === tab) {
      classes.push('selected')
    }
    return classes.join(' ')
  }

  useEffect(() => {
    if (!loaded) {
      act.brand.load()
    }
  }, [loaded])

  useEffect(() => {
    validate({ brand, setErrors: act.local.setValidationErrors })
  }, [brand])

  if (!loaded) return <Loading />

  return (
    <>
      <div className='header'>
        <BackButton url='/admin/settings' />
        <h1>Brand & Content Settings</h1>
      </div>

      <div className='row margin-bottom'>
        <div className='tabs'>
          <div className={tabClasses('brandSettings')} onClick={() => setTab('brandSettings')}>Brand Settings</div>
          <div className={tabClasses('volunteerPage')} onClick={() => setTab('volunteerPage')}>Volunteer Page</div>
          <div className={tabClasses('textContent')} onClick={() => setTab('textContent')}>Text Content</div>
        </div>
      </div>

      {tab == 'brandSettings' && <BrandSettings /> }
      {tab == 'volunteerPage' && <VolunteerPageSettings /> }
      {tab == 'textContent' && <TextContent /> }


      <div className="actions margin-top">
        <ServerWaitButton className='button primary' onClick={act.brand.commit} disabled={!dirty || Object.keys(validationErrors).length > 0}>Save</ServerWaitButton>
        <ServerWaitButton className='margin-left half button red' onClick={() => act.brand.load()} disabled={!dirty}>Cancel</ServerWaitButton>
        {error ? (
          <div className="error">
            <p className="error">{error}</p>
          </div>
        ) : <></>}
      </div>
    </>
  )
}
